import { render } from "./Pointer.vue?vue&type=template&id=2ff80e68&scoped=true"
import script from "./Pointer.vue?vue&type=script&lang=js"
export * from "./Pointer.vue?vue&type=script&lang=js"

import "./Pointer.vue?vue&type=style&index=0&id=2ff80e68&lang=scss&scoped=true"

import exportComponent from "/Users/martin/www/forton/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff80e68"]])

export default __exports__